import React, { FC, useContext } from 'react';
import get from 'lodash/get';

import InputField from 'src/presentation/components/forms/InputField';
import FormContext from 'src/presentation/contexts/FormContext';
import MessageTypeSelector from '../MessageTypeSelector';
import NodeSelector from '../NodeSelector';
import { Content, Footer, Row } from 'src/presentation/components/pages/ivr/layouts/IvrLayout';
import {
  NodeProps,
  DESCRIPTION_PLACEHOLDER_TEXT,
  DESCRIPTION_LABEL_TEXT,
} from 'src/presentation/components/pages/ivr/constants/ivrConstants';

const MessageNode: FC<NodeProps> = ({ attr, disabled, nodeList, onSelectNode, readOnly }) => {
  const { workingState } = useContext(FormContext);
  const currentNodeId = get(workingState, `${attr}.id`);
  return (
    <>
      <Content>
        <Row>
          <InputField
            attr={`${attr}.name`}
            data-aid="name"
            disabled={disabled}
            label="Name"
            description="The name you can refer to link to other nodes"
            readOnly={readOnly}
          />
        </Row>

        <Row>
          <InputField
            attr={`${attr}.description`}
            data-aid="description"
            disabled={disabled}
            label={DESCRIPTION_LABEL_TEXT}
            placeholder={DESCRIPTION_PLACEHOLDER_TEXT}
            readOnly={readOnly}
          />
        </Row>

        <MessageTypeSelector attr={attr} readOnly={readOnly} disabled={disabled} />
      </Content>

      <Footer>
        <Row>
          <NodeSelector
            searchable
            attr={`${attr}.nextId`}
            data-aid="nextId"
            description="The next node in the IVR"
            disabled={disabled}
            label="Next Node"
            omittedNodeIds={[currentNodeId]}
            onSelectNode={onSelectNode}
            options={nodeList}
            readOnly={readOnly}
          />
        </Row>
      </Footer>
    </>
  );
};

export default MessageNode;
